const workTypes = {
    'meter_installation': 'عداد',
    'network_connection': 'تنفيذ شبكة',
    'emergency_response': 'طوارئ',
    'asset_replacement': 'إحلال',
    'network_upgrade': 'التعزيز',
    'medium_voltage_operations': 'الجهد المتوسط',
    'projects': 'المشاريع',
    'assets': 'الأصول',
    'ready_files': 'ملفات جاهزة',
}

export default workTypes